import PropTypes from 'prop-types';
import queryString from 'query-string';

import { ButtonV2 as Button } from '@utilities';

import { setEndpoint } from '@helpers';

import { containers } from '../../utilities/helpers';

import styles from './_index.module.scss';

const SSO = ({ next, setContainer }) => {
  const url = queryString.stringifyUrl({ query: { next }, url: setEndpoint('sso/login') });

  return (
    <div className={styles['sso']}>
      <h1>
        Welcome to Numerator.
        <br />
        Single data source. No gaps, just growth.
      </h1>
      <Button
        className={styles['sso-login-button']}
        data-testid="sso-login"
        onClick={() => {
          window.location.replace(url);
        }}
        shape="round"
        variant="primary"
      >
        Log In
      </Button>
      {import.meta.env.VITE_CONSULTANT_LOGIN === 'true' && (
        <div
          className={styles['sso-action']}
          data-testid="sso-action-consultant"
          onClick={() => setContainer(containers.CONSULTANT)}
        >
          Test Sign In
        </div>
      )}
      <h2>
        Access <strong>Numerator Insights</strong> and <strong>Numerator Verified Voices</strong>
        <br />
        from one login, making it easier than ever to close the
        <br />
        consumer say-do gap and find your next growth opportunity.
      </h2>
    </div>
  );
};

SSO.propTypes = {
  next: PropTypes.string,
  setContainer: PropTypes.func.isRequired,
};

export default SSO;
